import { GetListRequestParams, GetListResponse, instance } from "libs/api";

import { ApiRoutesSharing } from "../../constants";
import { SharingSchedulesListItem } from "../../sharing.types";

export const requestSharingSchedules = async (
  params: GetListRequestParams
): Promise<GetListResponse<SharingSchedulesListItem>> => {
  return await instance.get(ApiRoutesSharing.SharingSchedules, {
    params
  });
};
